import { render, staticRenderFns } from "./AddWidgetsDialog.vue?vue&type=template&id=670e4eff"
import script from "./AddWidgetsDialog.vue?vue&type=script&lang=js"
export * from "./AddWidgetsDialog.vue?vue&type=script&lang=js"
import style0 from "./AddWidgetsDialog.vue?vue&type=style&index=0&id=670e4eff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports